module.exports = __webpack_public_path__ + "img/hr-dark-dirt.948d65f7.png";